<template>
  <div>
    <loader :loading="loading"/>
    <shared-product-provide v-if="!loading" :product="product" :fromModule="fromModule" :toModule="toModule">
      <form-group :label="$t('department.label')" :error="getError('department', product.productId)" :required="true">
        <input type="text" class="form-input" v-model="product.department">
      </form-group>

      <form-group :label="$t('subDepartment.label')" :error="getError('subDepartment', product.productId)" :required="true">
        <input type="text" class="form-input" v-model="product.subDepartment">
      </form-group>

      <form-group :label="$t('gender.label')" :error="getError('gender', product.productId)" :required="false">
        <input type="text" class="form-input" v-model="product.gender">
      </form-group>

      <form-group :label="$t('warranty.label')" :error="getError('warranty', product.productId)" :required="true">
        <input type="text" class="form-input" v-model="product.warranty">
      </form-group>

      <form-group :label="$t('sellerType.label')" :error="getError('sellerType', product.productId)" :required="true">
        <select class="form-select" v-model="product.sellerType">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option value="1P">1P</option>
          <option value="3P">3P</option>
        </select>
      </form-group>

      <form-group :label="$t('sellerName.label')" :error="getError('sellerName', product.productId)" :required="true">
        <input type="text" class="form-input" v-model="product.sellerName">
      </form-group>
    </shared-product-provide>
  </div>
</template>

<script>
  import utils from 'utiljs-strings'
  import { AllHtmlEntities } from 'html-entities'
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'zoom'
      },
      maxDescriptionLengthDI: 6000,
      allowDescriptionHtml: true
    },
    data: () => ({
      loading: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.loading = true

      this.product.department = ''
      this.product.subDepartment = ''

      const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
      if (presetCategorization !== null && presetCategorization !== undefined) {
        this.product.department = presetCategorization.department
        this.product.subDepartment = presetCategorization.subDepartment
      }

      this.product.sellerType = null

      if (this.moduleDefinition.module.configs.seller) {
        if (this.moduleDefinition.module.configs.seller.name) {
          this.product.sellerName = this.moduleDefinition.module.configs.seller.name
        }

        if (this.moduleDefinition.module.configs.seller.type) {
          this.product.sellerType = this.moduleDefinition.module.configs.seller.type
        }
      }

      if (this.product.warranty) {
        this.product.warranty = utils.stripTags(AllHtmlEntities.decode(this.product.warranty), '')
      } else if (this.product.warrantyTime) {
        this.product.warranty = `${this.product.warrantyTime} meses`
      }

      this.loading = false
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()
        this.product.variations.forEach(variation => {
          if (variation.attributes &&
              ('voltage' in variation.attributes) &&
              (variation.attributes.voltage === null || variation.attributes.voltage === undefined)) {
            this.addError({
              sku: variation.sku,
              property: `attributes.voltage`,
              error: {
                message: 'required',
                value: 1
              }
            })
          }
        })

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => ({
            brand: this.product.brand,
            condition: 'new',
            color: variation.attributes.color !== undefined && variation.attributes.color !== '' && variation.attributes.color !== null ? variation.attributes.color : null,
            grid: this.getGrid(variation),
            gridType: this.getType(variation),
            description: this.product.description,
            ean: variation.ean,
            height: variation.height,
            images: variation.images.length ? variation.images : null,
            integrationCode: this.product.productId,
            length: variation.length,
            original: {
              product: this.product,
              variation: variation
            },
            price: variation.price,
            primaryCategory: this.product.category,
            productId: this.product.productId,
            sku: variation.sku,
            source: this.fromModule,
            stock: variation.stock,
            title: this.product.title,
            weight: variation.weight,
            width: variation.width,
            department: this.product.department,
            subDepartment: this.product.subDepartment,
            gender: this.product.gender,
            warranty: this.product.warranty,
            sellerType: this.product.sellerType,
            sellerName: this.product.sellerName
          })
        )
      },
      getType (variation) {
        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return 'Único'
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'zoom')
      }
    },
    watch: {
      category (value) {
        this.product.category = value.code
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?3e5bb1fc